/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import"./has.js";function n(n){}function t(n){}function o(n){return()=>n}const c=(...n)=>n;export{n as neverReached,t as neverReachedSilent,c as tuple,o as typeCast};
